import React, { useEffect } from "react";
import { graphql } from "gatsby"
import { useI18next } from 'gatsby-plugin-react-i18next';
import { translateHead, capitalizeWords, createUrlString } from "../helpers/helpers";
import { useMixpanel } from 'gatsby-plugin-mixpanel'

import Layout from "../components/layout/layout"
import SearchBar from "../components/search/search-bar"
import EmojiGrid from "../components/emoji/emoji-grid"
import PagesNavigator from "../components/pages-navigator/pages-navigator";
import Seo from "../components/seo"

const TagTemplate = ({ pageContext, data }) => {
    const {
        tag,
        language,
        currentPage,
        totalPages,
        categories
    } = pageContext;

    const { navigate } = useI18next();
    const mixpanel = useMixpanel()

    const handleSearch = (query) => {
        navigate(`/search?query=${encodeURIComponent(query)}`);
    };

    useEffect(() => {
      mixpanel.track('page_view', {
        source: 'tag_page',
        tag: createUrlString(tag),
        language: language
      });
    }, [mixpanel, language, tag]);

    return (
        <Layout categories={categories}>
            <section>
                <SearchBar onSearch={handleSearch} />
                <div className="row g-0">
                    <div className="col content-col">
                        <h2 className="subtitle mb-4">{capitalizeWords(tag)}</h2>
                        <EmojiGrid emojis={data.emojis.nodes} />
                    </div>
                </div>
                <PagesNavigator currentPath={`/tags/${createUrlString(tag)}/`} numPages={totalPages} currentPage={currentPage}/>
            </section>
        </Layout>
    );
};

export const Head = ({ pageContext, data }) => {
    const { language, tag } = pageContext;

    const emojisOnTitle = data.emojis.nodes
        .sort((a, b) => a.codes.localeCompare(b.codes))
        .slice(0, 4)
        .map(emoji => emoji.emoji)
        .join('');

    const pageTitle = translateHead("emoji-tag.title", language, data.locales, {
        tag: capitalizeWords(tag),
        emojis: emojisOnTitle
    });

    const metaDescription = translateHead("emoji-tag.description", language, data.locales, {
        tag: capitalizeWords(tag),
    });

    return (
        <Seo title={pageTitle} description={metaDescription} />
    );
};

export const query = graphql`
  query($emojiIds: [String]!) {
    emojis: allMongodbTestEmojis(
      filter: { mongodb_id: { in: $emojiIds } }
    ) {
      nodes {
        description {
          en
          es
          fr
        }
        emoji
        name {
          es
          en
          fr
        }
        category
        related_emojis
        tags {
          en
          es
          fr
        }
        url
        codes
      }
    }
    locales: allLocale {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default TagTemplate;